// extracted by mini-css-extract-plugin
export default {"header_view":"QuoteHeader_header_view__1c2aP","fullWidth":"QuoteHeader_fullWidth__ZxqFO","quote_links":"QuoteHeader_quote_links__vUP68","btnlinkU":"QuoteHeader_btnlinkU__EVsk6"};